import styles from "./BottomSheetDragIndicator.module.scss"

export default function BottomSheetDragIndicator() {
    return (
        <div className={styles.base}>
            <span className={styles.indicator} />
        </div>
    )
}
